export default function parseReceiptLoyaltyRewards(loyaltyEngagementSummary) {
  const rewardsSummary = {
    earnedNewReward: false,
    offerTitle: null,
    pointsJustEarned: 0
  };

  const [pointConversion] = loyaltyEngagementSummary.pointConversions;

  /**
   * This is a temporary fix until we fully support the new shape
   * of pointConversions, where each pointConversion will have
   * an award which can be of the type `OfferAward` or `PointAward`.
   * If it's an `OfferAward` then there will be an `offer` nested
   * on the award.
   */
  if (pointConversion?.offer) {
    rewardsSummary.earnedNewReward = true;
    rewardsSummary.offerTitle = pointConversion.offer.title;
  }

  loyaltyEngagementSummary.awards.forEach((award) => {
    if (award.currency?.isPrimaryCategory && award.isPointAward) rewardsSummary.pointsJustEarned += award.pointsEarned;
  });

  return rewardsSummary;
}
